import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function KpiCard({
  label,
  value,
  delta,
  hint,
  icon: Icon,
  accent = "#A7F3D0",
  testid,
}) {
  const positive = typeof delta === "number" ? delta >= 0 : null;
  return (
    <div
      data-testid={testid}
      className="card-elev rounded-xl p-4 relative overflow-hidden transition-all"
    >
      <div
        className="absolute top-0 left-0 right-0 h-[3px]"
        style={{ background: accent }}
      />
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-[0.08em] font-medium text-[#6B7280]">
          {label}
        </div>
        {Icon && (
          <div
            className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0"
            style={{ background: `${accent}40` }}
          >
            <Icon className="w-3.5 h-3.5" style={{ color: "#0E5B52" }} strokeWidth={2} />
          </div>
        )}
      </div>
      <div className="mt-2.5 font-display font-semibold text-[#0F2A26] text-2xl leading-tight tabular-nums">
        {value}
      </div>
      <div className="mt-1 flex items-center gap-1.5 text-xs">
        {positive !== null && (
          <span
            className={`flex items-center gap-0.5 font-medium ${
              positive ? "text-[#065F46]" : "text-[#991B1B]"
            }`}
          >
            {positive ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
            {Math.abs(delta)}%
          </span>
        )}
        {hint && <span className="text-[#9CA3AF]">{hint}</span>}
      </div>
    </div>
  );
}
